import { add, remove, listen, qsa } from '@fluorescent/dom';

const selectors = {
  dots: '.navigation-dot',
};

const navigationDots = (container, slider) => {
  const navigationDots = qsa(selectors.dots, container);
  const events = [];

  navigationDots.forEach(dot => {
    events.push(listen(dot, 'click', e => _handlePageDot(e)));
  });

  const _handlePageDot = e => {
    e.preventDefault();

    if (e.target.classList.contains('is-selected')) return;

    const { slideIndex } = e.target.dataset;
    slider.select(slideIndex);
    slider.pausePlayer();
  };

  const update = cellIndex => {
    const activeClass = 'is-selected';

    navigationDots.forEach(dot => remove(dot, activeClass));

    add(navigationDots[cellIndex], activeClass);
  };

  const unload = () => {
    events.forEach(unsubscribe => unsubscribe());
  };

  return { update, unload };
};

export default navigationDots;
